import React from 'react';
interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Buttons or a view switcher, right-aligned on desktop. */
  actions?: React.ReactNode;
}
export function PageHeader({
  title,
  subtitle,
  actions
}: PageHeaderProps) {
  return <header className="mb-6 flex flex-wrap items-end justify-between gap-4" data-id="element-507" data-mp="2dcmxu6dyh954">
      <div className="min-w-0" data-id="element-508" data-mp="28fmrrvh3w6e0">
        <h1 className="text-2xl font-bold tracking-tight text-stone-900 sm:text-3xl" data-id="element-509" data-mp="28c8tozfh6jcd">
          {title}
        </h1>
        {subtitle && <p className="mt-1.5 text-sm text-stone-500" data-id="element-510" data-mp="1gnp4mslutja2">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-shrink-0 flex-wrap items-center gap-2" data-id="element-511" data-mp="1uf3ot2rhzqip">
          {actions}
        </div>}
    </header>;
}